import { AxiosInstance } from 'axios';
import { Group } from 'referral-types';
import { simulate } from './utils';
import type { FormFields } from '../components/group/group.schema';

export const baseEndpoint = 'group';

export class GroupApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getGroup(id: string): Promise<Group> {
    await simulate();
    const response = await this.apiInstance.get(`/${id}`);

    return response.data; 
  }

  async getGroupsForPage(pageId: string): Promise<Array<Group>> {
    await simulate();
    const response = await this.apiInstance.get(`/page/${pageId}`);

    return response.data;
  }

  async createGroup(pageId: string, payload: FormFields): Promise<Group> {
    await simulate();
    const response = await this.apiInstance.post(`/page/${pageId}`, payload);

    return response.data;
  }

  async updateGroup(groupId: string, payload: Partial<FormFields>): Promise<Group> {
    await simulate();
    const response = await this.apiInstance.put(`/${groupId}`, payload);

    return response.data;
  }

  async deleteGroup(groupId: string): Promise<Group> {
    await simulate();
    const response = await this.apiInstance.delete(`/${groupId}`);

    return response.data;
  }

  async reorderGroupsForPage(pageId: string, groupIds: string[]): Promise<Array<Group>> {
    await simulate();
    const response = await this.apiInstance.put(`/page/${pageId}/reorder`, { groupIds });

    return response.data;
  }
}
